// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__10uAN","label":"SetPasswdForm_label__28n6o"};